import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const defaultCategory = {
  id: null,
  name: null,
  weightOld: null,
  weightNew: null,
  weightNewComing: null,
  createdDate: null,
  pillarId:  null,
};

const INITIAL_STATE = fromJS({
  category: fromJS(defaultCategory),
  fetching: false,
  posting: false,
  updating: false,
  message: '',
  deleting: false
});

function createCategory(state, action) {
  return state
    .set('posting', true)
}

function createCategorySuccess(state, action) {
  return state
    .set('posting', false)
    .set('message', 'Category was created successfully')
}

function createCategoryFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to create category'
  }
  return state
    .set('posting', false)
    .set('message', msg)
}

function getCategoryById(state, action) {
  return state
    .set('fetching', true)
}

function getCategoryByIdSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('category', fromJS(action.payload.body))
}

function getCategoryByIdFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to load category'
  }
  return state
    .set('fetching', false)
    .set('message', msg)
}

function updateCategory(state, action) {
  return state
    .set('updating', true)
}

function updateCategorySuccess(state, action) {
  return state
    .set('updating', false)
}

function updateCategoryFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to update category'
  }
  return state
    .set('updating', false)
    .set('message', msg)

}

function resetState(state, action) {
  return INITIAL_STATE;
}

function changeCategoryStore(state, action) {
  return state
    .set(action.payload.key, action.payload.value)
}

function deleteCategory(state, action) {
  return state
    .set('deleting', true)
}

function deleteCategorySuccess(state, action) {
  return state
    .set('deleting', false)
}

function deleteCategoryFailed(state, action) {
  return state
    .set('deleting', false)
}

export const category = createReducer(INITIAL_STATE, {
  [ActionTypes.CREATE_CATEGORY]: createCategory,
  [ActionTypes.CREATE_CATEGORY_SUCCESS]: createCategorySuccess,
  [ActionTypes.CREATE_CATEGORY_FAILED]: createCategoryFailed,
  [ActionTypes.GET_CATEGORY_BY_ID]: getCategoryById,
  [ActionTypes.GET_CATEGORY_BY_ID_SUCCESS]: getCategoryByIdSuccess,
  [ActionTypes.GET_CATEGORY_BY_ID_FAILED]: getCategoryByIdFailed,
  [ActionTypes.UPDATE_CATEGORY]: updateCategory,
  [ActionTypes.UPDATE_CATEGORY_SUCCESS]: updateCategorySuccess,
  [ActionTypes.UPDATE_CATEGORY_FAILED]: updateCategoryFailed,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.CHANGE_CATEGORY_STORE]: changeCategoryStore,
  [ActionTypes.DELETE_CATEGORY]: deleteCategory,
  [ActionTypes.DELETE_CATEGORY_SUCCESS]: deleteCategorySuccess,
  [ActionTypes.DELETE_CATEGORY_FAILED]: deleteCategoryFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/category.js